module.exports = __webpack_public_path__ + "static/media/tg-1.2f30b7a1.svg";